var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapTileProject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "150px",
    height: "150px",
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "map-tile-project") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 72.5,
    cy: 57.5,
    r: 41.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "map-tile-project"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Project-Map-Icon-Circle-Default",
    transform: "translate(2.000000, 16.000000)",
    fillOpacity: 0.1,
    fill: "#2E8FFA"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Square",
    transform: "translate(3.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.9246481,0.728520014 L137.960144,23.2411971 C140.679952,24.2125571 140.679952,25.7874429 137.960144,26.7588029 L74.9246481,49.27148 C72.2048401,50.24284 67.7951599,50.24284 65.0753519,49.27148 L2.03985604,26.7588029 C-0.679952013,25.7874429 -0.679952013,24.2125571 2.03985604,23.2411971 L65.0753519,0.728520014 C67.7951599,-0.242840005 72.2048401,-0.242840005 74.9246481,0.728520014 Z",
    id: "Rectangle-2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "House",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sub-roof",
    transform: "translate(0.000000, 2.031250)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-27",
    fill: "#FFE842",
    points: "16.8411182 15.702414 -1.8189894e-12 35.3045544 0.81933852 36.5625 16.8411182 17.8694613"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-28",
    fill: "#AB8038",
    points: "18.4149773 17.3912413 2.98084068 35.1870667 2.28115145 34.4285324 17.3671099 17.3912413"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-27",
    fill: "#FFE842",
    points: "29.9200656 10.624289 13.0789474 30.2264294 13.8982859 31.484375 29.9200656 12.7913363"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-28",
    fill: "#AB8038",
    points: "31.4939247 12.3131163 16.059788 30.1089417 15.3600988 29.3504074 30.4460572 12.3131163"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-27",
    fill: "#FFE842",
    points: "42.999013 5.078125 26.1578947 24.6802655 26.9772333 25.938211 42.999013 7.24517238"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-28",
    fill: "#AB8038",
    points: "44.5728721 6.76695234 29.1387354 24.5627778 28.4390462 23.8042434 43.5250046 6.76695234"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-27",
    fill: "#FFE842",
    points: "56.0779603 0 39.2368421 19.6021405 40.0561806 20.860086 56.0779603 2.16704738"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-28",
    fill: "#AB8038",
    points: "57.6518194 1.68882734 42.2176828 19.4846528 41.5179936 18.7261184 56.603952 1.68882734"
  })), /*#__PURE__*/React.createElement("g", {
    id: "house",
    transform: "translate(1.868421, 2.031250)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-25",
    fill: "#757575",
    points: "39.7264701 30.8798319 68.2697297 45.6602435 26.8744979 62.7979983 1.55593102 50.4063107"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-24",
    fill: "#898989",
    points: "0.527482322 35.5453333 0.527482322 52.4513418 40.6297459 34.0619649 40.6297459 17.2016258"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-20",
    fill: "#D8D8D8",
    points: "16.3304013 16.25 28.4356107 43.7124366 26.9849232 62.9321067 0 52.2254262 0 34.3652677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8190283,26.907501 L57.376469,0.035749169 C49.0105201,9.26717686 44.4185931,14.4007998 43.6006879,15.436618 C42.7827828,16.4724362 41.6420547,17.2210955 40.1785038,17.6825958 L39.9318653,33.6401704 L68.8190283,45.5877289 L68.8190283,26.907501 Z",
    id: "Path-23",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.236884,59.6938399 L36.6094889,58.6353549 L36.6094889,45.5077181 L31.0457276,47.7740277 L31.0457276,60.9947304 L26.4600394,62.8641086 L26.4600394,43.2122159 L68.9692094,26.8624802 L68.9692094,45.5350378 L34.236884,59.6938399 Z M48.7542257,40.4295931 L43.1904645,42.6959027 L43.1904645,56.0393785 L48.7542257,53.5572299 L48.7542257,40.4295931 Z M60.8989625,35.3514681 L55.3352013,37.6177777 L55.3352013,50.9612535 L60.8989625,48.4791049 L60.8989625,35.3514681 Z",
    id: "Path-22",
    fill: "#9E9E9E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "roof",
    transform: "translate(15.881579, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-7",
    fill: "#FCE63B",
    points: "0.685251292 19.4158441 0.892838255 17.4864773 12.9698004 46.2651061 12.7622134 48.1944729"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-7",
    fill: "#F9B83F",
    points: "0.892838255 17.4864773 3.06531296 16.6032626 15.1422751 45.3818914 12.9698004 46.2651061"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-19",
    fill: "#BE8C30",
    points: "15.1381267 45.3835779 14.8102039 47.3747318 12.7668253 48.2054628 12.9780071 46.2617697"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-7",
    fill: "#FCE63B",
    points: "13.7200995 14.1165557 13.9276865 12.187189 26.0046486 40.9658178 25.7970617 42.8951845"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-7",
    fill: "#F9B83F",
    points: "13.9276865 12.187189 16.1001612 11.3039742 28.1771234 40.082603 26.0046486 40.9658178"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#F9B83F",
    points: "3.40498226 18.6246894 14.2673558 14.2086158 15.1963529 16.4223565 4.33397935 20.8384301"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#F9B83F",
    points: "6.50163922 26.003825 17.3640128 21.5877514 18.2930099 23.8014921 7.43063631 28.2175657"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#F9B83F",
    points: "9.59829618 33.3829606 20.4606697 28.966887 21.3896668 31.1806277 10.5272933 35.5967013"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#F9B83F",
    points: "12.6949531 40.7620962 23.5573267 36.3460226 24.4863238 38.5597633 13.6239502 42.9758369"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-19",
    fill: "#BE8C30",
    points: "28.172975 40.0842896 27.8450521 42.0754435 25.8016736 42.9061744 26.0128553 40.9624814"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-7",
    fill: "#FCE63B",
    points: "26.7549478 8.81726737 26.9625348 6.88790059 39.0394969 35.6665294 38.8319099 37.5958962"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-7",
    fill: "#F9B83F",
    points: "26.9625348 6.88790059 29.1350095 6.00468587 41.2119716 34.7833147 39.0394969 35.6665294"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#F9B83F",
    points: "16.4398305 13.3254011 27.3022041 8.90932744 28.2312012 11.1230681 17.3688276 15.5391418"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#F9B83F",
    points: "19.5364875 20.7045367 30.398861 16.288463 31.3278581 18.5022037 20.4654846 22.9182773"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#F9B83F",
    points: "22.6331444 28.0836723 33.495518 23.6675986 34.4245151 25.8813393 23.5621415 30.2974129"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#F9B83F",
    points: "25.7298014 35.4628079 36.5921749 31.0467342 37.521172 33.2604749 26.6587985 37.6765485"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-19",
    fill: "#BE8C30",
    points: "41.2078232 34.7850012 40.8799004 36.7761551 38.8365218 37.6068861 39.0477036 35.663193"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#F9B83F",
    points: "29.4746788 8.02611271 40.3370523 3.61003908 41.2660494 5.82377976 30.4036759 10.2398534"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#F9B83F",
    points: "32.5713357 15.4052483 43.4337093 10.9891747 44.3627064 13.2029153 33.5003328 17.618989"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#F9B83F",
    points: "35.6679927 22.7843839 46.5303662 18.3683103 47.4593633 20.5820509 36.5969898 24.9981246"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#F9B83F",
    points: "38.7646496 30.1635195 49.6270232 25.7474459 50.5560203 27.9611865 39.6936467 32.3772602"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-7",
    fill: "#FCE63B",
    points: "39.7897961 3.51797901 39.997383 1.58861223 52.0743452 30.3672411 51.8667582 32.2966078"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-7",
    fill: "#F9B83F",
    points: "39.997383 1.58861223 42.1698577 0.705397506 54.2468199 29.4840263 52.0743452 30.3672411"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-19",
    fill: "#BE8C30",
    points: "54.2426715 29.4857128 53.9147486 31.4768668 51.8713701 32.3075977 52.0825519 30.3639046"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapTileProject);
export default __webpack_public_path__ + "static/media/map-tile-project.ebadc75a.svg";
export { ForwardRef as ReactComponent };